<template>
    <modal @modal-close="handleClose" size="small" tabindex="-1" role="dialog">
        <div class="bg-white rounded shadow-lg overflow-hidden pb-10 sm:pb-0">
            <!-- @todo extract into comment form component -->
            <!-- <comment-form @submit="addComment" @close="handleClose" /> -->
            <div class="bg-light relative flex flex-wrap sm:items-end sm:justify-between py-6 px-8" class2="pb-4">
                <button @click="handleClose" type="button" class="absolute top-0 right-0 text-gray-600 hover:text-gray-700 mt-4 mr-6 py-1 px-2">
                    <i class="far fa-times fa-lg"></i>
                </button>

                <div class="text-center sm:text-left">
                    <h4 class="text-xl sm:text-2xl font-semibold mb-0">
                        <i class="fad fa-pencil mr-2"></i>
                        Add Comment
                    </h4>

                    <!-- <h5 class="text-base text-muted mb-0 mt-2">
                        Replying to {{ resource.title }}
                    </h5> -->
                </div>
            </div>

            <div class="p-8">
                <form @submit.prevent="addComment" action="/comments" method="POST">
                    <!-- @todo csrf -->

                    <div class="form-group">
                        <label for="message" class="w-full font-semibold">
                            Message
                        </label>

                        <div class="w-full">
                            <textarea v-model="body" :class="{ 'is-invalid': hasError('body') }" name="message" value="" id="message" class="form-control" rows="5" required autofocus></textarea>
                            <span v-cloak v-if="hasError('body')" class="invalid-feedback">
                                <strong>{{ firstError('body') }}</strong>
                            </span>
                        </div>
                    </div>

                    <div class="form-group sm:flex sm:justify-center sm:items-center mb-0">
                        <div class="w-full sm:w-6/12 mt-0 sm:mt-2">
                            <btn :loading="loading" :disabled="disabled" type="submit" class="btn btn-primary btn-block btn-lg font-semibold text-lg">
                                Save Comment
                            </btn>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </modal>
</template>

<script>
import { Errors } from 'form-backend-validation';

export default {
    props: [
        'resource-type',
        'resource-id',
        'parent-id',
    ],

    data: () => ({
        body: "",
        loading: false,
        errors: new Errors()
    }),

    created() {},

    mounted() {},

    computed: {
        disabled() {
            return this.loading;
        }
    },

    methods: {
        hasError(field) {
            return this.errors.has(field);
        },

        firstError(field) {
            if (this.hasError(field)) {
                return this.errors.first(field);
            }
        },

        addComment() {
            this.loading = true;

            axios.post('/api/comments', {
                resource_type : this.resourceType,
                resource_id   : this.resourceId,
                parent_id     : this.parentId,
                body          : this.body
            })
                .then(response => {
                    const comment = response.data;

                    this.$emit('added', comment);
                    this.handleClose();
                })
                .catch(err => {
                    console.error(err);
                    const response = err.response;
                    if (response.status === 422) {
                        this.errors = new Errors(response.data.errors);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        handleClose() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
